import React from "react"
import "./DeviceInfoCard.css"
import ApprovalResultComponent from "./ApprovalResultComponent"
import OmniAural from "omniaural"
import DateTimeDisplayComponent from "./DateTimeDisplayComponent"
import { setDefaultDevice } from "../services"

export const DeviceInfoCard = ({
  device,
  showDeviceId,
  onDeregister,
  showMFALabel,
  isDefaultDevice,
  userRegistrationKey
}) => {
  const isDeregistered = !!device.deregistered_at
  const lastChallenge = device.challenges?.[0] || {}
  const last30DaysChallenges =
    device.challenges?.filter((challenge) => {
      const challengeDate = new Date(challenge.responded_at)
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
      return challengeDate >= thirtyDaysAgo
    }) || []
  const MFAOnly = device.second_factor && !device.primary_factor
  return (
    <div className="device-info-card">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h2 className="title">{device.device_name}</h2>
        <div className="action-labels-container">
          {MFAOnly && showMFALabel && (
            <span
              onClick={() => {
                OmniAural.showModal({
                  data: device,
                  type: "mfa_warning"
                })
              }}
              className="action-label">
              MFA Only
            </span>
          )}
          {!isDeregistered && (
            <span
              onClick={() => {
                if (isDefaultDevice) return
                OmniAural.showModal({
                  data: device,
                  type: "make_default_device",
                  onConfirm: async () => {
                    await setDefaultDevice(device.device_id, userRegistrationKey)
                    window.location.reload()
                  }
                })
              }}
              className={`action-label ${isDefaultDevice && "not-actionable"}`}>
              {isDefaultDevice ? "Default" : "Make Default"}
            </span>
          )}
        </div>
      </div>
      <div className="body">
        <div className="item">
          <span className="item-title">Platform</span>
          <span className="item-content">{device.platform}</span>
        </div>
        <div className="item">
          <span className="item-title">App Version</span>
          <span className="item-content">{device.app_version}</span>
        </div>

        <div className="item">
          {showDeviceId && (
            <>
              <span className="item-title">Device ID</span> {device.device_id}
            </>
          )}
        </div>
        {!isDeregistered && lastChallenge.responded_at && (
          <>
            <div className="item">
              <span className="item-title">Last Attempt</span>
              <span className="item-content">
                <DateTimeDisplayComponent date={lastChallenge.responded_at} />
              </span>
            </div>
            <div className="item">
              <span className="item-title">Result</span>
              {lastChallenge.response_status && (
                <>
                  <span className="item-content">
                    <ApprovalResultComponent status={lastChallenge.response_status} />
                  </span>
                </>
              )}
            </div>
            {lastChallenge.deny_message && (
              <div className="item">
                <span className="item-title">Reason</span>
                <span className="item-content">{lastChallenge.deny_message}</span>
              </div>
            )}
          </>
        )}
        {isDeregistered && (
          <>
            <div className="item">
              <span className="item-title">Registered on</span>
              <span className="item-content">
                <DateTimeDisplayComponent date={device.created_at} />
              </span>
            </div>
            <div className="item">
              <span className="item-title">Deregistered on</span>
              <span className="item-content">
                <DateTimeDisplayComponent date={device.deregistered_at} />
              </span>
            </div>
            <div className="item">
              <span className="item-title">Reason</span>
              <span className="item-content">{device.deregistered_reason}</span>
            </div>
          </>
        )}
      </div>
      {last30DaysChallenges.length ? (
        <span
          className="text-link"
          onClick={() =>
            OmniAural.showModal({
              data: { ...device, challenges: last30DaysChallenges },
              type: "challenges"
            })
          }>
          View all authentication attempts in the last 30 days
        </span>
      ) : (
        <span className="item-comment">0 authentication attempt(s) in the last 30 days</span>
      )}
      {!device.deregistered_at && (
        <button className="full-width-button" onClick={() => onDeregister(device)}>
          DEREGISTER THIS DEVICE
        </button>
      )}
    </div>
  )
}
